/** Should be the same as in Figma color palette */
export const colors = {
  primary: {
    base: '#1961FF',
    disabled: '#E7E7E7',
    disabledFloating: '#AFC7FF', // e.g. disabled floating button
    active: '#1C46AC',
    loading: '#5F8EFF',
    faded: '#D7E3FF',
  },
  secondary: {
    base: '#EBF1FF',
    active: '#E8EBF1',
    loading: '#EFF4FF',
    background: '#F5F5F5',
  },
  text: {
    base: '#1B1D21',
    disabled: '#B1B1B1',
    faded: '#949596',
  },
  primitive: {
    white: '#FFFFFF',
    grey: '#F0F0F0',
    darkGrey: '#E3E3E3',
    background: '#FAFAFA',
    black: '#343434',
    pureBlack: '#000000',
    faded: '#718096',
    shadow: '#e7e7e780',
  },
  alert: {
    base: '#EE6352',
    faded: '#FCE0DC',
    heavy: '#CF1322',
    active: '#A8493D',
  },
  success: {
    base: '#21CE99',
    faded: '#D3F5EB',
  },
  warning: {
    base: '#F7B567',
    faded: '#FDF0E1',
  },
  highlight: {
    base: '#FF5E76',
    faded: '#FFEAED',
    active: '#D44056',
  },
};
